const getRawAttributeByName = (attributesRaw: { name: string; value: any }[], name: string) =>
	attributesRaw.find((rawAttribute) => rawAttribute.name === name)

export default getRawAttributeByName
